/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_No_TitleInputs */

const en_ticket_no_title = /** @type {(inputs: Ticket_No_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No title`)
};

const ja_ticket_no_title = /** @type {(inputs: Ticket_No_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトルなし`)
};

const fr_ticket_no_title = /** @type {(inputs: Ticket_No_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sans titre`)
};

const de_ticket_no_title = /** @type {(inputs: Ticket_No_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Titel`)
};

/**
* | output |
* | --- |
* | "No title" |
*
* @param {Ticket_No_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_no_title = /** @type {((inputs?: Ticket_No_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_No_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_no_title(inputs)
	if (locale === "ja") return ja_ticket_no_title(inputs)
	if (locale === "fr") return fr_ticket_no_title(inputs)
	return de_ticket_no_title(inputs)
});